import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@mui/material';

const GradeDialog = ({
  open,
  studentGrade,
  setStudentGrade,
  enrolledStudents,
  handleGradeSubmission,
  setOpenGradeDialog,
}) => {
  return (
    <Dialog open={open} onClose={() => setOpenGradeDialog(false)}>
      <DialogTitle>Grade Assessment</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel>Student</InputLabel>
          <Select
            value={studentGrade.studentId || ''}
            onChange={(e) => setStudentGrade({ ...studentGrade, studentId: e.target.value })}
          >
            {enrolledStudents.map((student) => (
              <MenuItem key={student.id} value={student.id}>
                {`${student.firstName} ${student.lastName}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Grade"
          fullWidth
          type="number"
          value={studentGrade.grade || ''}
          onChange={(e) => setStudentGrade({ ...studentGrade, grade: e.target.value })}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenGradeDialog(false)}>Cancel</Button>
        <Button onClick={handleGradeSubmission} variant="contained">
          Submit Grade
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GradeDialog;